module.exports = __webpack_public_path__ + "static/media/icon@2x.b0bb3383.png";